// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","light-caption":"whatWeOffer-module__light-caption___1UrcD","lightCaption":"whatWeOffer-module__light-caption___1UrcD"};